import React, { useContext } from 'react';
import { Button, Grid, Stack, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Share as ShareIcon, Archive as ArchiveIcon, Add as AddIcon, Search as SearchIcon, ViewList as ViewListIcon, ViewKanban as ViewKanbanIcon, Assessment as AssessmentIcon } from '@mui/icons-material';
import SaveAsTemplateIcon from '@mui/icons-material/SaveAs';
import ModalContext from '../../../shared/ModalContext/ModalContext';
import { useNavigate } from 'react-router-dom';

export default function IdealCandidateHeader({
  idealCandidate,
  onPassiveSearch,
  onArchive,
  onUnarchive,
  onShare,
  onAddCandidate,
  viewMode,
  onSetViewMode,
}) {
  const { openModal, closeModal } = useContext(ModalContext);
  const navigate = useNavigate();

  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      onSetViewMode(newViewMode);
    }
  };

  return (
    <Grid container alignItems="center" spacing={{ xs: 1, md: 2 }} sx={{ mb: 3 }}>
      <Grid item>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>{idealCandidate?.title}</Typography>
      </Grid>
      <Grid item xs />
      <Grid item>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 2 }} alignItems="center">
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleViewModeChange}
            aria-label="view mode"
            size="small"
          >
            <ToggleButton value="board" aria-label="board view">
              <ViewKanbanIcon />
            </ToggleButton>
            <ToggleButton value="table" aria-label="table view">
              <ViewListIcon />
            </ToggleButton>
          </ToggleButtonGroup>

          {/*
          <Button 
              onClick={() => navigate(`/ideal-candidates/${idealCandidate.id}/report`)}
              startIcon={<AssessmentIcon />}
            >
              View Report
          </Button>
          */}
          <Button variant="outlined" size="small" color="primary" startIcon={<SearchIcon />} onClick={onPassiveSearch} sx={{ textTransform: 'none', borderRadius: '20px' }}>
            Passive Search
          </Button>

          <Button variant="contained" size="small" disableElevation color="primary" startIcon={<AddIcon />} onClick={onAddCandidate} sx={{ textTransform: 'none', borderRadius: '20px' }}>
            Add Candidate
          </Button>

          <Button variant="text" size="small" onClick={onShare} sx={{ textTransform: 'none' }}>
            <ShareIcon sx={{ mr: 1 }} /> Share
          </Button>

          {idealCandidate?.status !== 'ARCHIVED' ? (
            <Button variant="text" size="small" onClick={onArchive} sx={{ textTransform: 'none' }}>
              <ArchiveIcon sx={{ mr: 1 }} /> Archive
            </Button>
          ) : (
            <Button variant="text" size="small" onClick={onUnarchive} sx={{ textTransform: 'none' }}>
              <ArchiveIcon sx={{ mr: 1 }} /> Unarchive
            </Button>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
}